import _get from 'lodash/get';
import _toLower from 'lodash/toLower';

import localStore from 'utils/localStore';
import { STORAGE_KEYS } from 'utils/DICTIONARY';

export default function preventErrorLog(userInfo) {
  const userData =
    userInfo || JSON.parse(localStore.get(STORAGE_KEYS.USER_DATA));
  const email = _toLower(_get(userData, 'email', ''));

  return email.includes('infosec') && email.includes('auctane.com');
}
